import { useMemo } from 'react';
import { useGetAllAffiliationsQuery } from '../redux/services/affiliation-api';

/**
 * Zonas que se le pueden asignar a un Secretario de Zona.
 *
 * Con `campId` se acota al campamento activo: el endpoint devuelve las afiliaciones
 * hijas de la afiliación de ese camp, que son sus zonas reales. Es lo que se quiere en
 * el panel — se administra un campamento a la vez, y ofrecer las zonas de otro solo
 * sirve para asignar por error una que dejaría al secretario sin clubes que ver.
 *
 * Sin `campId` devuelve las de toda la organización, que es lo que valida el servidor
 * en `addUser` y `updateRole` (`Affiliation.distinct('zone', { parent: { $ne: null } })`):
 * el filtro es de interfaz, no una regla nueva. Por eso quien pinta el Select tiene que
 * seguir mostrando la zona que el usuario ya tiene aunque no salga en esta lista.
 *
 * En ambos casos solo cuentan las afiliaciones hijas —las raíz no tienen zona— y se
 * descarta la cadena vacía, que el schema pone por defecto y el servidor rechaza.
 */
export const useZoneCatalog = ({ campId = null, skip = false } = {}) => {
  const { data: affiliations, isFetching, isError } = useGetAllAffiliationsQuery(
    campId ? { campId } : undefined,
    { skip }
  );

  const zones = useMemo(() => {
    const list = (affiliations || []).filter(a => a.parent && a.zone).map(a => a.zone);
    return [...new Set(list)].sort((a, b) => a.localeCompare(b, 'es', { numeric: true }));
  }, [affiliations]);

  return { zones, isFetching, isError };
};

export default useZoneCatalog;
